import { type RefObject, useCallback } from 'react'

import {
	MARGIN_PROPERTY,
	type SnackbarPosition,
} from '../../constants/constants'

export const useIsMoving = ({
	snackbarRef,
	position,
	initialMargin,
}: {
	snackbarRef: RefObject<HTMLHeadElement | null>
	position: SnackbarPosition
	initialMargin: string
}) => {
	const isMoving = useCallback((): boolean => {
		const currentFontSizePx = Number.parseInt(
			getComputedStyle(document.documentElement).fontSize,
			10
		)

		const initialMarginPx = Number.parseFloat(initialMargin) * currentFontSizePx
		const marginProperty = MARGIN_PROPERTY[position]
		const currentMarginPx = snackbarRef.current
			? Number.parseInt(
					window.getComputedStyle(snackbarRef.current)[marginProperty],
					10
				)
			: 0

		if (Number.isNaN(initialMarginPx) || Number.isNaN(currentMarginPx)) {
			return false
		}

		return initialMarginPx - currentMarginPx !== 0
	}, [position])

	return { isMoving }
}
